import { formatDisplayDate } from '@/config';
import { Button, Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SeatingSummary from './SeatingSummary';
import { BusDto } from '@/__generated';

type Props = {
  bus: BusDto;
};

export default function BusOtherInfo({ bus }: Props) {
  const { t } = useTranslation();
  const [showDetail, toggleDetail] = React.useState<boolean>(false);

  return (
    <>
      <Button
        type="link"
        size="small"
        onClick={() => {
          toggleDetail(true);
        }}
      >
        {t('busesPage_OtherDetail')}
      </Button>
      <Modal
        okButtonProps={{ style: { display: 'none' } }}
        cancelText={t('Close')}
        onCancel={v => toggleDetail(false)}
        open={showDetail}
        width={300}
        title={t('busesPage_OtherDetail')}
      >
        <div style={{ padding: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {t('busesPage_AcquisitionDate')}
            <b>{formatDisplayDate(bus.acquisitionDate)}</b>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {t('busesPage_BaggageCapacity')}
            <b>{bus.baggageCapacity}</b>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {t('busesPage_BaggageCapacity')}
            <b>{bus.baggageCapacity}</b>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {t('busesPage_InitialColor')}
            <b style={{ color: bus.initialColor }}>{bus.initialColor}</b>
          </div>
        </div>

        {showDetail ? <SeatingSummary seatingModelId={bus.seatingModelId || ''} /> : null}
      </Modal>
    </>
  );
}
